import React, { useEffect } from 'react';
import TradePage from '../TradePage';
import { useCexSocketConnected, useExoticMode } from '../../recoil';
import { connectCexEngineSocket, disconnectCexEngineSocket, getCexEngineSocket } from '../../services/cex-engine-socket.service';
import { getAccessToken } from '../../utils/tokens';
import { API_ENDPOINTS } from '../../utils/constants';

export default function index() {
  const [, setExoticMode] = useExoticMode();
  const [, setConnected] = useCexSocketConnected();

  useEffect(() => {
    setExoticMode(true);
    connectCexEngineSocket(
      API_ENDPOINTS.cexws,
      getAccessToken()
    ).onConnected(() => {
      setConnected(true);
    });

    const pingInterval = setInterval(() => {
      const socket = getCexEngineSocket();
      if (socket) socket.ping();
    }, 18_000);

    return () => {
      disconnectCexEngineSocket();
      setConnected(false);
      setExoticMode(false);
      clearInterval(pingInterval);
    };

  }, [setExoticMode]);

  return (
    <>
      <TradePage />
    </>
  );
}
